<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentTimeSheet /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/manager/dashboard/HeaderDash.vue'
import SideMenu from '@/components/manager/dashboard/SideMenu.vue'
import ContentTimeSheet from '@/components/manager/dashboard/modules/timesheet/ContentTimeSheet.vue'

export default 
{
  name: 'TimeSheet',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentTimeSheet
  }
}
</script>
<style>


</style>